import React, { cloneElement, type JSX } from "react";

import UiTooltip from "@/components/Ui/Tooltip";
import UiLabelSuperPoolTooltip from "@/components/Ui/Label/SuperPool/Tooltip";
import UiLabelSuperPoolPositionTooltip from "@/components/Ui/Label/SuperPool/PositionTooltip";

import Link from "next/link";
import dictionaryConfig from "@/../config/dictionary.config";
import { SupERC20, SupPool } from "@repo/core-ui";
import { SupText } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface UiLabelTagProps {
  label: JSX.Element | string;
  type?: "superpool" | "erc-20";
  icon?: JSX.Element;
  tooltipContent?: JSX.Element | string;
  link?: string;
  className?: string;
}

export default function UiLabelTag({ label, icon, type, tooltipContent, link, className }: UiLabelTagProps) {
  const iconElement = type === "superpool" ? <SupPool /> : type === "erc-20" ? <SupERC20 /> : icon;

  const iconNode = iconElement
    ? cloneElement(iconElement, {
        className: "text-primary-800 w-3 h-3",
      })
    : undefined;

  const tooltipNode = type === "superpool" ? <UiLabelSuperPoolTooltip /> : type === "erc-20" ? <UiLabelSuperPoolPositionTooltip /> : tooltipContent;

  const linkNode = type === "superpool" || type === "erc-20" ? dictionaryConfig.superPools.helpArticle : link;

  const content = (
    <UiTooltip arrowPlacement="right" content={tooltipNode ?? ""} enable={tooltipNode !== undefined} color="default" popperClassName="bg-neutral-50">
      <SupText
        variant="caption"
        as="div"
        className={twMerge(
          "inline-flex items-center gap-0.5 rounded-l-lg rounded-br-lg border-[.5px] border-primary-500 bg-primary-50 px-2 py-0.5 text-[11px] text-primary-800",
          className,
          tooltipNode && "cursor-help"
        )}
      >
        {iconNode}
        <span>{label}</span>
      </SupText>
    </UiTooltip>
  );

  return linkNode ? (
    <Link className="inline-flex flex-none" href={dictionaryConfig.superPools.helpArticle} target="_blank">
      {content}
    </Link>
  ) : (
    content
  );
}
